import { render, staticRenderFns } from "./wxinfo.vue?vue&type=template&id=6f259e88&scoped=true&"
import script from "./wxinfo.vue?vue&type=script&lang=js&"
export * from "./wxinfo.vue?vue&type=script&lang=js&"
import style0 from "./wxinfo.vue?vue&type=style&index=0&id=6f259e88&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6f259e88",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("D:\\work\\zy_frontend\\node_modules\\vue-hot-reload-api\\dist\\index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('6f259e88')) {
      api.createRecord('6f259e88', component.options)
    } else {
      api.reload('6f259e88', component.options)
    }
    module.hot.accept("./wxinfo.vue?vue&type=template&id=6f259e88&scoped=true&", function () {
      api.rerender('6f259e88', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/wxreport/components/wxinfo.vue"
export default component.exports